"use client";
import React, { useState } from "react";
import Image from "next/image";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import styles from "./BusinessSolutionsSection.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

// 👉 React Icon for arrow
import { HiArrowUpRight } from "react-icons/hi2";

// ICONS
import headerIcon from "@/app/assets/bussol.svg";
 

import Serv1 from "@/app/assets/serv1.png";
import Serv2 from "@/app/assets/serv2.png";
import Serv3 from "@/app/assets/serv3.png";
import Serv4 from "@/app/assets/serv4.png";
import Serv5 from "@/app/assets/serv5.png";
import Serv6 from "@/app/assets/serv6.png";
import Serv7 from "@/app/assets/serv7.png";
import Serv8 from "@/app/assets/serv8.png";

import Bus1 from "@/app/assets/bus1.svg";
import Bus2 from "@/app/assets/bus2.svg";
import Bus3 from "@/app/assets/bus3.svg";
import Bus4 from "@/app/assets/bus4.svg";
import Bus5 from "@/app/assets/bus5.svg";
import Bus6 from "@/app/assets/bus6.svg";
import Bus7 from "@/app/assets/bus7.svg";
import Bus8 from "@/app/assets/bus8.svg";

import Bus01 from "@/app/assets/bus01.svg";
import Bus02 from "@/app/assets/bus02.svg";
import Bus03 from "@/app/assets/bus03.svg";
import Bus04 from "@/app/assets/bus04.svg";
import Bus05 from "@/app/assets/bus05.svg";
import Bus06 from "@/app/assets/bus06.svg";
import Bus07 from "@/app/assets/bus07.svg";
import Bus08 from "@/app/assets/bus08.svg";
import Link from "next/link";

const ServiceCard = ({ title, tag, desc, price, img, featureIcon, featIcon, featureText, linksOn }: any) => (
  <div className={styles.cardBox}>

    {/* IMAGE AREA */}
    <div className={styles.cardImageArea}>

      <div className={styles.cardTopLeft}>
        <span  >
          <Image src={featIcon} width={40} height={40} alt="cloud" />
        </span>
      </div>

      <span className={styles.cornerTopRight}></span>
      <span className={styles.cornerBottomRight}></span>

      <Image src={img} alt={title} className="img-fluid w-100 h-auto" />

      <div className={styles.featureOverlay}>
        <Image src={featureIcon} width={20} height={20} alt="icon" />
        <div className="clearfix"></div>
        <p
  className={styles.featureText}
  dangerouslySetInnerHTML={{
    __html: featureText.replace(/\n/g, "<br/>")
  }}
></p>
      </div>
    </div>

    {/* DETAILS */}
    <div className={styles.cardDetails}>
      <div className={styles.titleRow}>
        <h3 className={styles.cardTitle}>{title}</h3>
        <span className={styles.categoryTag}>{tag}</span>
      </div>

      <p className={styles.cardDesc}>{desc}</p>

      <div className={styles.cardDivider}></div>

      <div className={styles.bottomRow}>
        <p className={styles.price}> From  
        <div className="clearfix"></div>
        <span className={styles.priceNumber}>{price}</span>
        </p>

        {/* UPDATED WITH REACT-ICON ARROW */}
        <Link href={linksOn || "#"}>
        <Button className={styles.customBtn}>
          Customize<HiArrowUpRight className={styles.btnArrowIcon} />
        </Button>
        </Link>

      </div>
    </div>
  </div>
);

export default function BusinessSolutionsSection() {

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setStatus("success");
        setEmail("");
      } else {
        setStatus(data.error || "error");
      }
    } catch (err) {
      console.log(err);
      setStatus("error");
    }
  };

  const cards = [
    {
      title: "Managed Cloud Hosting",
      tag: "FULLY MANAGED",
      desc:
        "Our managed cloud hosting service gives you the opportunity to worry less, letting you focus on the growth of your website with complete peace of mind.",
      price: "$10.00/Mo",
      img: Serv1,
      featureIcon: Bus1,
            featIcon: Bus01,

      featureText: "Hands-off\nmaintenance",
      linksOn: "/managed-cloud-hosting",
    },
    {
      title: "Domains",
      tag: "NAME & IDENTITY",
      desc:
        "Secure your online identity with ease. Register, transfer, and manage domain names all in one place, backed by fast support and intuitive tools.",
      price: "$2.20/Yr",
      img: Serv2,
      featureIcon: Bus2,
      featIcon: Bus02,
      featureText: "Easy domain\ncontrol",
      linksOn: "/domain-registrations",
      
 

    },
    {
      title: "GPU/AI/ML",
      tag: "AI Compute Power",
      desc:
        "Harness high-performance GPU infrastructure designed for AI and machine learning workloads—powerful, scalable, and ready for compute-heavy tasks.",
      price: "$129.00/mo",
      img: Serv3,
      featureIcon: Bus3,
            featIcon: Bus03,

      featureText: "Blazing fast\ntraining",
      linksOn: "https://clients.temok.com/store/gpu-servers",
    },
    {
      title: "Dedicated Servers",
      tag: "Full Power",
      desc:
        "Experience raw performance and full control with our dedicated servers—perfect for demanding applications and custom configurations.",
      price: "$49.00/mo",
      img: Serv5,
      featureIcon: Bus5,
            featIcon: Bus05,

      featureText: "100% resource\ncontrol",
      linksOn: "/dedicated-servers-usa",
    },
    {
      title: "Cyber Security",
      tag: "Advanced Threat Protection",
      desc:"Safeguard your digital assets with enterprise-level cyber security solutions, including real-time threat detection, advanced firewalls, intrusion prevention, and continuous monitoring to protect your infrastructure from evolving cyber threats.",
      price: "$7.99/mo",
      img: Serv8,
      featureIcon: Bus8,
            featIcon: Bus08,

      featureText: "Reliable\nconnectivity",
      linksOn: "/acronis-cyber-protect-cloud",
    },
    {
      title: "Databases",
      tag: "SMART STORAGE",
      desc:
        "Deploy and scale your favorite databases with ease. From MySQL to MongoDB, enjoy optimized performance and automated backups.",
      price: "$21.00/Mo",
      img: Serv4,
      featureIcon: Bus4,
      featIcon: Bus04,
      featureText: "Reliable,\nfast queries",
      linksOn: "/managed-mysql-hosting",
    },

    {
      title: "Storage",
      tag: "CLOUD STORAGE",
      desc:
        "Secure, scalable, and lightning-fast storage solutions for files, backups, or data lakes—available when and how you need it.",
      price: "$3.95/mo",
      img: Serv6,
      featureIcon: Bus6,

      featIcon: Bus06,
            featureText: "Flexible\ncapacity",
            linksOn: "https://www.temok.com/linux-virtual-private-server-vps-usa",
    },
    {
      title: "Apps",
      tag: "1‑Click Apps",
      desc:
        "Deploy popular apps with just a click—from WordPress to eCommerce tools—on infrastructure optimized for speed and reliability.",
      price: "$59.00/mo",
      img: Serv7,
      featureIcon: Bus7, 
      featIcon: Bus07,
 featureText: "Fast app\nlaunch",
 linksOn: "https://www.temok.com/linux-virtual-private-server-vps-usa",
    },

  ];

  return (
    <section className={styles.sectionWrapper}>

      {/* HEADER */}
      <Container className={styles.headerContainer}>
        <Row className="align-items-center justify-content-between">

          <Col lg={3} md={4} sm={12} className="d-flex align-items-center mb-3 mb-md-0">
            <Image src={headerIcon} width={20} alt="icon" className="me-2" />
            <span className={styles.headerTitle}>Business Solutions</span>
          </Col>

          <Col lg={5} md={4} sm={12} className="d-md-flex justify-content-md-end ">
          <form onSubmit={handleSubmit} className="w-100">
              <div className={`d-md-flex justify-content-md-end`}>
                {/* INPUT */}
                <div className={styles.inputWrapper}>
                  <span className={styles.emailIcon}>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </span>

                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    className={`${styles.emailInput} code-font`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                {/* BUTTON */}
                <Button
                  className={`${styles.earlyBtn} code-font fw-semibold`}
                  type="submit"
                  disabled={status === "loading"}
                >
                  {status === "loading" ? "Please wait..." : "Subscribe Now"}
                  <HiArrowUpRight className={styles.btnArrowIcon} />
                </Button>
              </div>

              {/* STATUS MESSAGES */}
              {status === "success" && (
                <p className="text-success mt-2">You are subscribed!</p>
              )}
              {status &&
                status !== "success" &&
                status !== "loading" && (
                  <p className="text-danger mt-2">{status}</p>
                )}
            </form>
          </Col>

        </Row>
        <div className={styles.bottomLine}></div>
      </Container>

      {/* REMAINING SAME */}
      <Container>
        <Row className="align-items-center mb-5">
          <Col lg={3}><p className={styles.subText}>Solutions to support your growth, performance, and global reach — without complexity.</p></Col>
          <Col lg={9}><h2 className={styles.mainHeading}>Scale your business</h2></Col>
        </Row>

        <Row>
          {cards.map((card, idx) => (
            <Col lg={6} className="mb-4" key={idx}>
              <ServiceCard {...card} />
            </Col>
          ))}
        </Row>
      </Container>

    </section>
  );
}
